export default "__VITE_ASSET__3289d5ce__"